import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.general.orderTagsSettings.title',
    defaultMessage: 'Order tags',
    description: 'title of the order tags settings on the configuration page',
  },
  feedback: {
    orderTagsSettingsUpdated: {
      defaultMessage: 'Order tags saved',
      id: 'pages.settings.general.orderTagsSettings.feedback.orderTagsSettingsUpdated',
      description: 'feedback on the successful update of order tags settings',
    },
    orderTagsSettingsNotUpdated: {
      id: 'pages.settings.general.orderTagsSettings.feedback.orderTagsSettingsNotUpdated',
      defaultMessage: 'Order tags could not be saved',
      description: 'feedback on the failed update of order tags settings',
    },
  },
  display: {
    label: {
      id: 'properties.tags',
      defaultMessage: 'Tags',
      description: 'label of the tags array field',
    },
  },
  editDrawer: {
    title: {
      id: 'pages.settings.general.orderTagsSettings.editDrawer.title',
      defaultMessage: 'Edit order tags',
      description: 'title of the edit order tags drawer',
    },
    tagsArrayField: {
      label: {
        id: 'properties.tags',
        defaultMessage: 'Tags',
        description: 'label of the tags array field',
      },
    },
    codeField: {
      label: {
        id: 'properties.code',
        defaultMessage: 'Code',
        description: 'label of the code field',
      },
      helperText: {
        id: 'pages.settings.general.orderTagsSettings.editDrawer.fields.helperText',
        defaultMessage: "Only use lowercase letters, numbers or '-'",
        description: 'helper text for the code field',
      },
    },
    colorField: {
      label: {
        id: 'properties.color',
        defaultMessage: 'Color',
        description: 'label of the color field',
      },
    },
    labelField: {
      label: {
        id: 'properties.label',
        defaultMessage: 'Label',
        description: 'label of the label field',
      },
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
